import { TUser, IUserGaDataLayerResponseSchema } from '../../types';

export function getCriteo(user?: TUser, userGaData?: IUserGaDataLayerResponseSchema | null) {
  const userCriteoEmail = user && user.isAuthenticated && user.criteoEmail;
  const CriteoEmail = (userGaData && userGaData.criteoEmail) || userCriteoEmail || '';

  return {
    CriteoEmail,
    CriteoNewCustomer: (userGaData && String(userGaData.criteoNewCustomer)) || '',
    CriteoProducts: [],
  };
}
